import React, { useState, useEffect, useRef } from "react";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import CancelIcon from "@mui/icons-material/Cancel";
import { useAddUserMutation, useLazySubadminRolesListQuery, useLazySubadminStatusQuery, useLazySubadminViewQuery, useLazyUserStatusQuery, useLazyViewUserQuery, useListUserMutation, useSubAdminAddMutation, useSubAdminEditMutation, useSubAdminListMutation, useUpdateUserMutation } from "../../redux/api/api";
import apiRequest from "../../redux/api/apiRequest";
import { edit_icon, eye_icon, profile, toggle_off, toggle_on, view_icon } from "../../../assets/imgs";
import { Table } from "../../../components/Table/Table";
import { EMAIL, isValidEmail, PASS } from "../../redux/api/Constants";
import { cityList, countriesList, stateList } from "../../redux/api/Country";

const SubAdmin = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [popup, setPopup] = useState(false);
    const [viewpopup, setViewPopup] = useState(false);
    const [deletePopup, setDeletePopup] = useState(false);
    const givenpermissions = JSON.parse(localStorage.getItem("user_permission"));
    const [list, setList] = useState([]);
    const [unList, setUnList] = useState([]);
    const [visible, setVisible] = useState(false);
    const [pagination, setPagination] = useState("");
    const [password, setPassword] = useState();
    const [confirmPassword, setConfirmPassword] = useState();
    const [type, setType] = useState();
    const [tabs, setTabs] = useState(1);
    const [page, setPage] = useState(1);
    const [deviceList, setDeviceList] = useState([]);
    const [loader, setLoader] = useState(false);
    const [error, setError] = useState(false);
    const [imageUrl, setImageUrl] = useState(false);
    const [devicepop, setDevicePop] = useState(false);
    const search = useRef(null);
    const [userData, setUserData] = useState({
        email: "",
        name: "",
        phone: "",
        role_id: "",
        city: "",
        state: "",
        country: "",
        password: "",
        password_confirmation: "",
    });
    const [countryId, setCountryId] = useState("");
    const [stateId, setStateId] = useState("");
    const [cityId, setCityId] = useState("");
    const [count, setCount] = useState();
    const [roleId, setRoleId] = useState();
    const [roles, setRoles] = useState("");
    const [rolesList, setRoleslist] = useState([]);
    console.log(countryId, stateId, Number(cityId));

    const [listUser] = useSubAdminListMutation();
    const [listRole] = useLazySubadminRolesListQuery();
    const [addSubadmin] = useSubAdminAddMutation();
    const [editSubadmin] = useSubAdminEditMutation();
    const [userStatus] = useLazySubadminStatusQuery();
    const [viewUser] = useLazySubadminViewQuery();

    const getList = async (search) => {
        setList([]);
        const formdata = new FormData();
        formdata.append("rows", 10);
        formdata.append("page", page);
        formdata.append("type", tabs);
        formdata.append("search", search ? search : "");
        formdata.append("order", "asc");
        const res = await apiRequest(listUser, formdata);
        if (res?.status == "success") {
            setList(res?.lists);
            setCount(res?.pagination_meta?.total);
            setPagination(res?.pagination_meta);
        }
    };
    const getRolesList = async () => {
        const res = await apiRequest(listRole);
        if (res?.status == "success") {
            // let List = res?.role?.filter((item) => {
            // });
            let d = res?.data
            setUserData(d)
            setRoleslist(res?.roles);
            setRoleId(res?.data?.role_id)
        }
    };


    console.log(userData, 'roleId')

    useEffect(() => {
        getRolesList();
        if (givenpermissions?.includes("COMPANY-CAN-List-COMPANY_USERS")) {
            getList();
        }
    }, [page]);

    useEffect(() => {
        setPage(1);
        // getList();
    }, [tabs]);

    const userView = async (id) => {
        setPopup(true);
        const res = await apiRequest(viewUser, id);
        if (res?.status == "success") {
            setDeviceList(res?.user_data?.member_devices);
            setUserData(res?.user_data);
            let country = countriesList?.find(
                (item) => item?.name == res?.user_data?.country
            );
            let state = stateList?.find(
                (item) => item?.name == res?.user_data?.state
            );
            let city = cityList?.find((item) => item?.name == res?.user_data?.city);
            console.log(city, state, country);
            setCityId(Number(city?.id));
            setStateId(Number(state?.id));
            setCountryId(Number(country?.id));
        }
        console.log(res);
    };

    const Add = async (id) => {
        if (
            !userData?.name ||
            userData?.phone?.length < 8 ||
            !userData?.email ||
            !userData?.email.match(EMAIL)
        ) {
            setError(true);
            return;
        }
        if (!userData?.city || !userData?.state || !userData?.country) {
            setError(true);
            return;
        }
        if (type != 'edit') {
            if (userData?.password?.length < 8 ||
                userData?.password_confirmation?.length < 8 ||
                !userData?.password?.match(PASS) ||
                userData?.password != userData?.password_confirmation) {
                setError(true)
                return
            }
        }
        setError(false);

        let user = rolesList.find(item => item?.name == 'Company User')

        const formdata = new FormData();
        if (type == "edit") {
            formdata.append("user_id", id);
        }
        formdata.append("name", userData?.name);
        formdata.append("email", userData?.email);
        formdata.append("phone", userData?.phone);
        formdata.append("role", userData?.role_id);
        if (userData?.password) {
            formdata.append("password", userData?.password);
            formdata.append("password_confirmation", userData?.password_confirmation);
        }
        if (type == 'edit') {
            formdata.append("type", user?.id == userData?.role_id ? 1 : 2);
        } else {
            formdata.append("type", 2);
        }

        formdata.append("city", userData?.city);
        formdata.append("state", userData?.state);
        formdata.append("country", userData?.country);
        setLoader(true);
        const res = await apiRequest(
            type == "add" ? addSubadmin : editSubadmin,
            formdata, id
        );

        console.log('res', res);


        if (res?.status == "success") {
            toast.success(res?.message);
        }
        if (res?.status == "error") {
            toast.error(res?.message);
        }
        setUserData("");
        setStateId("");
        setCountryId("");
        setCityId("");
        getList();
        setPopup(false)
        setLoader(false)
    };

    const handleUpdate = (e) => {
        const { name, value } = e.target;
        if (name === "email") {
            setError((prev) => ({
                ...prev,
                emailErr: !isValidEmail(value) ? "Please enter a valid Email" : "",
            }));
        }
        setUserData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    console.log(userData);

    const handleSelect = (e) => {
        const { name, value } = e.target;
        let val = (
            name == "country" ? countriesList : name == "state" ? stateList : cityList
        )?.find((item) => {
            if (item?.id == value) {
                return true;
            }
        });
        if (name == "country") {
            setCountryId(Number(value));
            setStateId("");
            setCityId("");
        } else if (name == "state") {
            setStateId(Number(value));
            setCityId("");
        } else {
            setCityId(Number(value));
        }

        console.log(val, name, value);
        setUserData((prevState) => ({
            ...prevState,
            [name]: val?.name,
        }));
    };

    const handleStatus = async (id) => {
        const res = await apiRequest(userStatus, id);
        if (res?.status == "success") {
            toast.success(res?.message);
            getList();
        }
    };

    const Assigned = React.useMemo(
        () => [
            {
                Header: "S.No",
                accessor: "",
                Cell: ({ value, row }) => {
                    return <p>{row.index + 1}</p>;
                },
            },
            {
                Header: " Name",
                accessor: "name",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },
            {
                Header: " Email",
                accessor: "email",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },
            {
                Header: "Number",
                accessor: "phone",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },
            {
                Header: "View Device Details",
                accessor: "",
                Cell: ({ value, row }) => {
                    return (
                        <button
                            onClick={() => {
                                // if (givenpermissions?.includes("CAN-View-USERS")) {
                                userView(row.original.id);
                                setType("view");
                                setPopup(true);
                                // }
                            }}
                            className="cust-btn "
                        >
                            <img src={view_icon} alt="" className="mx-2 edit-btn " />
                        </button>
                    );
                },
            },
            {
                Header: "View Devices as Member ",
                accessor: "member_devices",
                Cell: ({ value, row }) => {
                    return (
                        <button
                            onClick={() => {
                                if (value?.length != 0) {
                                    // setDeviceList(value);
                                    userView(row.original.id);
                                    setDevicePop(true);
                                    setPopup(false)
                                }
                            }}
                            className="cust-btn "
                        >
                            {value?.length != 0 ? (
                                <img src={view_icon} alt="" className="mx-2 edit-btn " />
                            ) : (
                                "-"
                            )}
                        </button>
                    );
                },
            },
            {
                Header: "Status",
                accessor: "status",
                Cell: ({ value, row }) => {
                    return (
                        <div>
                            <button 
                                onClick={() => {
                                    if (givenpermissions?.includes("COMPANY-CAN-Status-COMPANY_USERS")) {
                                        handleStatus(row.original.id);
                                    }
                                }}
                                className={`border-0 ms-2 cust-btn `}
                            >
                                {value == 1 ? (
                                    <img className="toggle-btn" src={toggle_on} />
                                ) : (
                                    <img className="toggle-btn" src={toggle_off} />
                                )}
                            </button>
                        </div>
                    );
                },
            },
            {
                Header: "Action",
                accessor: "",
                Cell: ({ value, row }) => {
                    return (
                        <React.Fragment>
                            <div className="d-flex ac-jc">
                                {givenpermissions?.includes("COMPANY-CAN-Edit-COMPANY_USERS") && (
                                    <button
                                        onClick={() => {
                                            userView(row.original.id);
                                            setType("edit");
                                        }}
                                        className="cust-btn"
                                    >
                                        <img src={edit_icon} alt="" className="mx-2 edit-btn " />
                                    </button>
                                )}
                            </div>
                        </React.Fragment>
                    );
                },
            },
        ],
        []
    );


    console.log(deviceList);

    return (
        <div className="dashRightView home_section">
            <div className="d-flex ac-jb">
                <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary ">
                    Sub Admin
                </h2>
                {/* {givenpermissions?.includes("CAN-Add-USERS") && ( */}
                <button
                    onClick={() => {
                        setPopup(true);
                        setType("add");
                    }}
                    className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 white add-btn "
                >
                    {" "}
                    + Add Sub Admin
                </button>
                {/* )} */}
            </div>
            <div className="d-flex ac-js mt-2 ">
                <h4 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary mb-0 ">
                    Total Count :
                </h4>
                <h4 className="f2 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mb-0 ms-2">
                    {count}
                </h4>
                <h4 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary me-3 mb-0 ms-3">
                    Search
                </h4>
                <input
                    type="text"
                    className="input-pop ps-2"
                    placeholder=" Search"
                    onChange={(e) => {
                        getList(e.target.value);
                    }}
                />
            </div>
            {popup && (
                <div className="popup-design">
                    <div className="popup">
                        <div className="d-flex ac-jb">
                            <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary ">
                                User {type == "view" ? "View" : type == "add" ? "Add" : "Edit"}
                            </h2>
                            <button
                                onClick={() => {
                                    setPopup(false);
                                    setUserData({});
                                    setStateId("");
                                    setCountryId("");
                                    setRoles("");
                                    setCityId("");
                                    setError(false)
                                }}
                                className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary cust-btn"
                            >
                                <CancelIcon />
                            </button>
                        </div>
                        <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                            Email
                        </h4>
                        <input
                            type="email"
                            className="input-pop ps-2 w-100"
                            placeholder=" Email Address"
                            name="email"
                            onChange={(e) => {
                                handleUpdate(e);
                            }}
                            value={userData?.email}
                            disabled={type == "view" || type == "edit" ? true : false}
                        />
                        {error && (!userData?.email || !userData?.email?.match(EMAIL)) && (
                            <p className="err">Enter Valid Email</p>
                        )}
                        <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                            Name
                        </h4>
                        <input
                            type="text"
                            className="input-pop ps-2 w-100"
                            placeholder=" Name"
                            name="name"
                            onChange={(e) => {
                                handleUpdate(e);
                            }}
                            value={userData?.name}
                            disabled={type == "view" ? true : false}
                        />
                        {error && !userData?.name && <p className="err">Enter Name</p>}
                        <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                            Phone Number
                        </h4>
                        <input
                            type="number"
                            className="input-pop ps-2 w-100"
                            placeholder="Phone Number"
                            name="phone"
                            onChange={(e) => {
                                if (e.target.value.length <= 8) {
                                    handleUpdate(e);
                                }
                            }}
                            value={userData?.phone}
                            disabled={type == "view" ? true : false}
                        />{error && (userData?.phone?.length < 8 || !userData?.phone) && (
                            <p className="err">Enter Valid Phone Number</p>
                        )}
                        <div className="mt-3">
                            <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18  ">
                                Primary  Password
                            </h4>
                            <div className="input-pop mb-2 w-100 d-flex ac-jb">
                                <input readOnly={type ? false : true}
                                    type={visible ? "text" : "password"}
                                    maxLength={20}
                                    className="cust-btn  w-90"
                                    placeholder="Password"
                                    name="password"
                                    autoComplete="off"
                                    onChange={(e) => {
                                        handleUpdate(e);
                                    }}
                                    value={userData?.password}
                                />
                                <img
                                    src={eye_icon}
                                    onClick={() => setVisible(!visible)}
                                    className="eye-icon pointer"
                                    alt=""
                                />
                            </div>
                            {error &&
                                (userData?.password?.length < 8 ||
                                    !userData?.password?.match(PASS)) && (
                                    <p className="err">
                                        {!userData?.password
                                            ? "Enter Your password"
                                            : !userData?.password?.match(PASS)
                                                ? "Must include one special char & capital leteer"
                                                : "Enter Minimum 8 Charactors"}
                                    </p>
                                )}
                        </div>
                        <div className="mt-3">
                            <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18  ">
                                Confirm Primary Password
                            </h4>
                            <div className="input-pop mb-2 w-100 d-flex ac-jb">
                                <input readOnly={type ? false : true}
                                    type={visible ? "text" : "password"}
                                    maxLength={20}
                                    className="cust-btn w-90"
                                    placeholder=" Confirm Password"
                                    name="password_confirmation"
                                    autoComplete="off"
                                    onChange={(e) => {
                                        handleUpdate(e);
                                    }}
                                    value={userData?.password_confirmation}
                                />
                                <img
                                    src={eye_icon}
                                    onClick={() => setVisible(!visible)}
                                    className="eye-icon pointer"
                                    alt=""
                                />
                            </div>
                            {error &&
                                (userData?.password_confirmation?.length < 8 ||
                                    userData?.password !=
                                    userData?.password_confirmation) && (
                                    <p className="err mb-0">
                                        {!userData?.password_confirmation
                                            ? "Enter Confirm Password"
                                            : userData?.password_confirmation?.length < 8
                                                ? "Enter Minimum 8 Charactors"
                                                : "Password Mismatch"}
                                    </p>
                                )}
                        </div>
                        <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                            Roles
                        </h4>
                        <select
                            className="input-pop ps-2 w-100"
                            name="role_id"
                            onChange={(e) => {
                                handleUpdate(e);
                            }}
                            value={userData?.role_id}
                        // disabled
                        >

                            <option value={""}> -- Select --</option>
                            {rolesList?.map((item) => {
                                return <option value={item?.id}> {item?.name}</option>;
                            })}
                        </select>
                        {error && !userData?.role_id && (
                            <p className="err">Select Your Role</p>
                        )}
                        <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                            Country
                        </h4>
                        <select
                            className="input-pop ps-2 w-100"
                            name="country"
                            onChange={(e) => {
                                handleSelect(e);
                            }}
                            value={countryId}
                        // disabled={type == "view" ? true : false}
                        >
                            <option value={""}> -- Select --</option>
                            {countriesList?.map((item) => {
                                return <option value={item?.id}> {item?.name}</option>;
                            })}
                        </select>
                        {error && !userData?.country && (
                            <p className="err">Enter Country</p>
                        )}
                        <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                            State
                        </h4>
                        <select
                            className="input-pop ps-2 w-100"
                            name="state"
                            onChange={(e) => {
                                handleSelect(e);
                            }}
                            value={stateId}
                        // disabled={type == "view" || !countryId ? true : false}
                        >
                            <option value={""}> -- Select --</option>
                            {stateList
                                ?.filter((data) => data?.country_id == countryId)
                                ?.map((item) => {
                                    return <option value={item?.id}> {item?.name}</option>;
                                })}
                        </select>
                        {error && !userData?.state && (
                            <p className="err">Enter State</p>
                        )}
                        <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                            City
                        </h4>
                        <select
                            className="input-pop ps-2 w-100"
                            name="city"
                            onChange={(e) => {
                                handleSelect(e);
                            }}
                            value={cityId}
                        // disabled={type == "view" || !countryId || !stateId ? true : false}
                        >
                            <option value={""} className="">
                                {" "}
                                -- Select --
                            </option>
                            {cityList
                                ?.filter((data) => data?.state_id == stateId)
                                ?.map((item) => {
                                    return <option value={item?.id}> {item?.name}</option>;
                                })}
                        </select>

                        {error && !userData?.city && (
                            <p className="err">Enter City</p>
                        )}
                        {type == "view" && (
                            <div>

                                {userData?.devices?.map((item, index) => {
                                    return (
                                        <div
                                            key={index}
                                            className="d-flex sm-flex-column">
                                            <div>
                                                <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                                                    Device
                                                    {index + 1}
                                                </h4>
                                                <input
                                                    type="text"
                                                    className="input-pop ps-2 w-90"
                                                    placeholder="Device"
                                                    value={item?.device_name}
                                                    disabled
                                                />
                                            </div>
                                            <div>
                                                <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                                                    Location
                                                </h4>
                                                <input
                                                    type="text"
                                                    className="input-pop ps-2 w-90"
                                                    placeholder="Location"
                                                    value={item?.location_name}
                                                    disabled
                                                />
                                            </div>
                                            <div>
                                                <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                                                    No of Members
                                                </h4>
                                                <input
                                                    type="text"
                                                    className="input-pop ps-2 w-80"
                                                    placeholder="20"
                                                    value={item?.members_count}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                        {type != "view" && (
                            <div className="d-flex ac-jc mt-3">
                                <button
                                    onClick={() => {
                                        Add(userData?.id);
                                    }}
                                    className="login-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
                                >
                                    {loader && (
                                        <div
                                            class="spinner-border spinner-border-sm "
                                            role="status"
                                            style={{ marginRight: "5px" }}
                                        ></div>
                                    )}
                                    Submit
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            )}
            {devicepop && (
                <div className="popup-design">
                    <div className="popup" style={{ width: 800 }}>
                        <div className="d-flex ac-jb">
                            <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary ">
                                View Devices
                            </h2>
                            <button
                                onClick={() => {
                                    setDevicePop(false);
                                }}
                                className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary cust-btn"
                            >
                                <CancelIcon />
                            </button>
                        </div>
                        <div>
                            {deviceList?.length == 0 ? (
                                <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mt-5 text-center primary">
                                    No Devices Found
                                </h2>
                            ) : (
                                deviceList?.map((item, index) => {
                                    return (
                                        <div
                                            key={index}
                                            className="d-flex sm-flex-column">
                                            <div>
                                                <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                                                    Device
                                                    {index + 1}
                                                </h4>
                                                <input
                                                    type="text"
                                                    className="input-pop ps-2 w-90"
                                                    placeholder="Device"
                                                    value={item?.device_name}
                                                    disabled
                                                />
                                            </div>
                                            <div>
                                                <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                                                    Location
                                                </h4>
                                                <input
                                                    type="text"
                                                    className="input-pop ps-2 w-90"
                                                    placeholder="Location"
                                                    value={item?.location_name}
                                                    disabled
                                                />
                                            </div>
                                            <div className="w-50">
                                                <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                                                    Device owner
                                                </h4>
                                                <input
                                                    type="text"
                                                    className="input-pop ps-2 w-100"
                                                    placeholder="sakthivelsninos@gmail.com"
                                                    value={`${item?.owner?.device_owner_name} (${item?.owner?.device_owner_email})`}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                    );
                                })
                            )}
                        </div>
                    </div>
                </div>
            )}

            <Table
                columns={Assigned}
                data={list}
                show={true}
                pagecount={pagination}
                setPageno={setPage}
            />
            {imageUrl && (
                <div className="image-popup-design">
                    <div className="img-popup">
                        <div
                            className="d-flex ac-je w-100 pointer"
                            onClick={() => setImageUrl(false)}
                        >
                            <HighlightOffIcon />
                        </div>
                        <img src={imageUrl} className="image-pop" alt="" />
                    </div>
                </div>
            )}
        </div>
    );
};

export default SubAdmin